import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import ContactForm from '../components/contact-form'
import People from '../assets/contact-icon.png'
import styled from 'styled-components'
import Flip from 'react-reveal/Flip'
import { HelmetDatoCms } from 'gatsby-source-datocms'

const ContactPageWrapper = styled.div`
  #page-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .image-wrapper {
    margin: 20px 0px;
  }
`

const ContactPage = ({ data }) => (
  <ContactPageWrapper>
    <HelmetDatoCms seo={data.datoCmsContact.seoMetaTags} />
    <div className="section is-medium has-background-dark">
      <div className="container">
        <div className="columns">
          <div
            id="page-content"
            className="column is-half has-text-centered has-text-white"
          >
            <Flip left delay={200} fraction={0.75}>
              <div className="image-wrapper">
                <img src={People} alt="" />
              </div>
              <h1 className="title has-text-white">
                Let's Do Amazing Things Together.
              </h1>
              <p className="subtitle has-text-white">
                It all starts with an introduction.
              </p>
              <Helmet>
                <link
                  href="https://assets.calendly.com/assets/external/widget.css"
                  rel="stylesheet"
                />
                <script
                  src="https://assets.calendly.com/assets/external/widget.js"
                  type="text/javascript"
                />
              </Helmet>
              <button
                className="button has-text-dark"
                onClick={() =>
                  Calendly.showPopupWidget(
                    'https://calendly.com/megahouse-drob'
                  )
                }
              >
                Schedule Consultation
              </button>
            </Flip>
          </div>
          <div className="column is-half">
            <Flip right delay={700}>
              <div
                className="box has-background-dark"
                style={{ border: 'solid 3px #387b90' }}
              >
                <ContactForm />
              </div>
            </Flip>
          </div>
        </div>
      </div>
    </div>
    <div className="section has-background-primary">
      <div className="container">
        <div className="columns">
          <div className="column">
            <h2 className="title has-text-dark has-text-weight-bold">
              Hate Web Forms?
            </h2>
            <a
              className="subtitle"
              href="mailto:info@megahousecreative.com"
              target="_blank"
            >
              <p className="is-size-5-mobile has-text-dark">
                info@megahousecreative.com
              </p>
            </a>
          </div>
          <div className="column">
            <h2 className="title has-text-dark has-text-weight-bold">
              Give Us a Call
            </h2>
            <a className="subtitle" href="tel:6032302339" target="_blank">
              <p className="has-text-dark">(603) 230-2339</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </ContactPageWrapper>
)

export default ContactPage

export const ContactQuery = graphql`
  query ContactQuery {
    datoCmsContact {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/contact.js